import { gql, useQuery } from '@moonpig/web-core-graphql'
import { logger } from '@moonpig/web-core-monitoring'
import {
  GetProductDescriptionQuery,
  GetProductDescriptionQueryVariables,
} from './__generated__/useProductRequiresDescriptionQuery'

export const GetProductDescriptionGQL = gql`
  query GetProductDescription($productIds: [String]) {
    productLookup(productIds: $productIds) {
      products {
        __typename
        id
        description
      }
    }
  }
`

export const useProductDescriptionQuery = ({
  productId,
  skip,
}: {
  productId: string
  skip?: boolean
}): string | undefined => {
  const { data, error } = useQuery<
    GetProductDescriptionQuery,
    GetProductDescriptionQueryVariables
  >(GetProductDescriptionGQL, {
    variables: {
      productIds: [productId],
    },
    skip,
  })
  if (error) {
    logger.fixToday('Failed to load product description', {
      productId,
    })
    return
  }

  return data?.productLookup?.products[0]?.description
}
